import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import UserController from "./components/Controller/UserController";
import Auth from "./components/Controller/Auth";
import LogoutController from "./components/Controller/LogoutController";
import NotFound from "./components/Controller/NotFound";
import Inspiration from "./components/Inspiration/Inspiration";
import ContactUs from "./components/ContactUs/ContactUs";
import Signup from "./components/Signup/Signup";
import Error from "./components/Error/Error";
import UnprotectedController from "./components/Controller/Unprotected";
import LandingPage from "./components/LandingPage/LandingPage";
import Login from "./components/Login/Login";
import Information from "./components/information/Information";
import StageInformation from "./components/sections/StageInformation";
import NewPage from "./components/New/new";
import Usage from "./components/Usage/Usage";
import { ReactNotifications } from "react-notifications-component";
import OnDate from "./components/Ondate/OnDate";
import MostViewed from "./components/Search/MostViewed";
import CustomerEngagementTemplate from "./components/Engagetemp/CustomerEngagementTemplate";
import ManageEngagementTemplate from "./components/Engagetemp/Manage_Engagement_Template";
import MostViewedTopLink from "./components/Search/MostViewedTopLink";


import Gift from "./components/GES/Gift";

import Youtube from "./components/youtube/youtube";

import ExploreJourney from "./components/ExploreJourney/ExploreJourney";

import Dossier  from "./components/Dossier/Dossier";
import DossierCheck from "./components/Dossier/DossierCheck";
import ContactDossier from "./components/ContactDossier/ContactDossier";
import { ToastContainer  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Search = React.lazy(() => import("./components/Search/Search"));

function App() {
  return (
    <>
      <ToastContainer />
      {/* <Login/> */}
      {/* <Information /> */}

      <ReactNotifications />
      <Routes>
        <Route path="/" element={<UnprotectedController />}>
          <Route index element={<LandingPage />} />
          <Route path="/inspiration" element={<Inspiration />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
        </Route>
        <Route path="/gift/:token/:journey_type" element={<Gift />} />
        <Route path="auth" element={<Auth />} />
        <Route path="/auth/login/error" element={<Error />} />

        {/* Protected Routes */}
        <Route path="user" element={<UserController />}>
          <Route path="new" element={<NewPage />} />
          <Route path="usage" element={<Usage />} />
          <Route path="customer-engagement-template" element={<CustomerEngagementTemplate />} />
          <Route path="engagement-template/:journey_type" element={<ManageEngagementTemplate />} />
          <Route path="findContact/" element={<Search />} />
          <Route path="findContact/:journey_type" element={<Search />} />
          <Route
            path="findContact/:journey_type/mostviewed/:implId/:implname"
            element={<MostViewed />}
          />
          <Route
            path="findContact/:journey_type/mostviewedlink/:implId/:selecttype"
            element={<MostViewedTopLink />}
          />
          <Route
            path="findContact/:journey_type/:implId/:id"
            element={<Information />}
          />
          <Route
            path="findContact/:journey_type/:implId/onthisday"
            element={<OnDate />}
          />

          {/*  Youtube Frontend Cards */}
          <Route path="exploreJourney" element={<ExploreJourney />}>
            {/* <Route path="new" element={<New />} /> */}
          </Route>

          <Route path=":journey_type/dossiercheck" element={<DossierCheck />} />
          <Route path=":journey_type/contactdossier" element={<ContactDossier />} />
          <Route path="createdossier/:implId/:journey_type/:id" element={<Dossier />}>
            <Route
              path="displaydossier/:implId/:id"
              element={<Dossier />}
            ></Route>
          </Route>

          {/* <Route
            path="findContact/:implId/:id/:stage"
            element={<StageInformation />}
          /> */}
        </Route>

        <Route path="logout" element={<LogoutController />} />
        {/* <Route path="/*" element={<NotFound />} /> */}
      </Routes>

      {/*<LandingPage /> */}
      {/* <Search /> */}
      {/* <Login />
      <Information /> */}
    </>
  );
}

export default App;
